import { Fullscreen } from './fullscreen'
export * from './fullscreen'
export default Fullscreen